import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '../../../../providers/TenantProvider';
import { useI18n } from '../../../../i18n';
import { LoadingSpinner } from '../../../shared/components/LoadingSpinner';

// ═══════════════════════════════════════════════════════════════
// TenantSelector — Fullscreen tenant selector (placeholder)
// For now shows the current tenant; auto-redirects if only 1.
// Multi-tenant selector will be implemented when backend supports it.
// ═══════════════════════════════════════════════════════════════

export function TenantSelector() {
  const { tenant } = useTenant();
  const { t } = useI18n();
  const navigate = useNavigate();

  // If only 1 tenant (current behavior), auto-redirect
  useEffect(() => {
    if (tenant) {
      navigate('/admin', { replace: true });
    }
  }, [tenant, navigate]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F0F2F5',
        fontFamily: 'Montserrat, sans-serif',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 440,
          backgroundColor: '#fff',
          borderRadius: 16,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          overflow: 'hidden',
        }}
      >
        {/* Header with branding */}
        <div
          style={{
            background: 'linear-gradient(135deg, #1F3864 0%, #2F5496 100%)',
            padding: '32px 32px 28px',
            textAlign: 'center',
          }}
        >
          <h1 style={{ color: '#fff', fontSize: 22, fontWeight: 700, margin: 0 }}>{t.brandName}</h1>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 6 }}>
            {t.tenantSelector.subtitle}
          </p>
        </div>

        {/* Tenant list */}
        <div style={{ padding: '24px 32px 32px' }}>
          <p style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 16 }}>
            {t.tenantSelector.selectTenant}
          </p>

          {tenant ? (
            <button
              onClick={() => navigate('/admin')}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                padding: '16px 20px',
                backgroundColor: '#F8FAFC',
                border: '2px solid #E2E8F0',
                borderRadius: 12,
                cursor: 'pointer',
                transition: 'border-color 0.2s',
                fontFamily: 'inherit',
              }}
              onMouseOver={(e) => (e.currentTarget.style.borderColor = '#2F5496')}
              onMouseOut={(e) => (e.currentTarget.style.borderColor = '#E2E8F0')}
            >
              {/* Logo placeholder */}
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: 10,
                  background: 'linear-gradient(135deg, #1F3864, #2F5496)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontSize: 18,
                  fontWeight: 700,
                  flexShrink: 0,
                }}
              >
                {(tenant.nombreMarca ?? tenant.nombre).charAt(0).toUpperCase()}
              </div>
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: 15, fontWeight: 600, color: '#1F3864' }}>
                  {tenant.nombreMarca ?? tenant.nombre}
                </div>
                <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>
                  {tenant.slug} &middot; {tenant.plan}
                </div>
              </div>
            </button>
          ) : (
            <div style={{ textAlign: 'center', padding: 24 }}>
              <LoadingSpinner text={t.common.cargando} size="sm" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
